import "./App.scss";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "@citi-icg-172888/icgds-react";

import DNCALseExternal from "./external";
import LeadScore from "./internal/leadInternal";
import { useData } from "./services/context/DataContext";
import { useEffect, useState } from "react";
import AknowledgeScreen from "./AknowledgeScreen";

const App: React.FC = () => {
  const { setIsCardOpen, isCancelClicked, setIsCancelClicked } = useData();
  const [showAcknowledgeScreen, setShowAcknowledgeScreen] = useState(true);

  const handleAcknowledge = (item = "default") => {
    if (item == "acknowledge") {
      setShowAcknowledgeScreen(false);
      setIsCardOpen(true);
    } else {
      setShowAcknowledgeScreen(!showAcknowledgeScreen);
    }
  };

  const NotFound = () => {
    const redirectUrl = window.location.host.includes("uat")
      ? "https://uat.apps.citi.net/global/page-not-found"
      : "https://apps.citi.net/global/page-not-found";

    // Redirect to the appropriate URL
    useEffect(() => {
      window.location.href = redirectUrl;
    }, [redirectUrl]);

    return null; // Optionally, you can show a loading spinner here
  };

  useEffect(() => {
    const element = document.querySelector(".citi-font") as HTMLElement;
    if (
      element &&
      !window.parent.location.pathname.includes("contact-us") &&
      !window.parent.location.pathname.includes("insights")
    ) {
      element.style.background = "#f0f5f7";
    } else {
      element.style.background = "#fff";
    }
  }, []);

  useEffect(() => {
    if (isCancelClicked) {
      handleAcknowledge();
      setIsCancelClicked(false);
    }
  }, [isCancelClicked]);

  return (
    <div className="citi-font">
      {/* {errorStatus && (
        <Alert type="danger" showIcon closable>
          {errorStatus}
        </Alert>
      )} */}
      <ErrorBoundary showIcon={true} closable={true}>
        <Routes>
          <Route
            path="/CCBContactus"
            element={
              showAcknowledgeScreen ? (
                <AknowledgeScreen onAcknowledge={handleAcknowledge} />
              ) : (
                <DNCALseExternal onAcknowledge={handleAcknowledge} />
              )
            }
          />
          <Route
            path="/CCBContactus/eppublic/contactus"
            element={
              showAcknowledgeScreen ? (
                <AknowledgeScreen onAcknowledge={handleAcknowledge} />
              ) : (
                <DNCALseExternal onAcknowledge={handleAcknowledge} />
              )
            }
          />
          {/* <Route path="/" element={window.origin.includes('dev') || window.origin.includes('localhost') ? <DNCALseExternal /> : <DNCALse />} /> */}
          <Route path="/webleads/internal" element={<LeadScore />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </div>
  );
};

export default App;
